import React from "react"

interface IconWrapperProps {
	icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>> | string
	alt?: string
	className?: string
	size?: number
}

const IconWrapper: React.FC<IconWrapperProps> = ({
	icon,
	className,
	size = 24,
	alt = "icon",
}) => {
	if (!icon) {
		return null
	}

	if (typeof icon !== "string") {
		const SvgIcon = icon as React.FunctionComponent<
			React.SVGProps<SVGSVGElement>
		>
		return (
			<SvgIcon
				className={className}
				width={size}
				height={size}
				fill="currentcolor"
				role="img"
				aria-label={alt}
			/>
		)
	}

	return (
		<img
			src={icon as string}
			alt={alt}
			className={className}
			style={{ width: size, height: size }}
		/>
	)
}

export default IconWrapper
